/**
 * Navegacion del modal de zoom (flechas, miniaturas, swipe y teclado).
 * Dawn de base solo abre el modal en la foto que clickeaste -- no trae
 * ninguna forma de cambiar de imagen una vez adentro. Esto se engancha
 * sobre la marca ".active" que ya usa product-modal.js (Dawn), sin
 * tocar ese archivo.
 */
(function () {
  function initModalNav(modal) {
    if (modal.dataset.rechileroNavInit) return;
    modal.dataset.rechileroNavInit = 'true';

    const content = modal.querySelector('.product-media-modal__content');
    const prevBtn = modal.querySelector('.product-media-modal__nav--prev');
    const nextBtn = modal.querySelector('.product-media-modal__nav--next');
    const thumbs = Array.from(modal.querySelectorAll('.product-media-modal__thumb'));
    const counterEl = modal.querySelector('[data-rechilero-modal-current]');

    if (!content || (!prevBtn && !nextBtn && thumbs.length === 0)) return;

    const items = Array.from(content.children);
    if (items.length < 2) return;

    function getActiveIndex() {
      return items.findIndex((el) => el.classList.contains('active'));
    }

    function syncThumbsAndCounter(index) {
      const activeEl = items[index];
      if (!activeEl) return;
      const mediaId = activeEl.getAttribute('data-media-id');
      thumbs.forEach((t) => {
        t.classList.toggle('product-media-modal__thumb--active', t.dataset.targetMediaId === mediaId);
      });
      const activeThumb = thumbs.find((t) => t.dataset.targetMediaId === mediaId);
      if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'center' });
      if (counterEl) counterEl.textContent = String(index + 1);
    }

    function setActiveByIndex(index) {
      const clamped = ((index % items.length) + items.length) % items.length;
      items.forEach((el) => el.classList.remove('active'));
      items[clamped].classList.add('active');
      syncThumbsAndCounter(clamped);
    }

    function go(delta) {
      setActiveByIndex(getActiveIndex() + delta);
    }

    // Dawn's ModalDialog cierra el modal con "pointerup" en cualquier click
    // afuera de deferred-media/product-model -- sin el stopPropagation, un
    // click en la flecha o una miniatura cerraria el modal en vez de
    // cambiar de foto.
    function stopAndRun(event, fn) {
      event.stopPropagation();
      fn();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (event) => stopAndRun(event, () => go(-1)));
      prevBtn.addEventListener('pointerup', (event) => event.stopPropagation());
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', (event) => stopAndRun(event, () => go(1)));
      nextBtn.addEventListener('pointerup', (event) => event.stopPropagation());
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) =>
        stopAndRun(event, () => {
          const index = items.findIndex((el) => el.getAttribute('data-media-id') === thumb.dataset.targetMediaId);
          if (index > -1) setActiveByIndex(index);
        })
      );
      thumb.addEventListener('pointerup', (event) => event.stopPropagation());
    });

    // Swipe horizontal (celular)
    let touchStartX = null;
    content.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );
    content.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) go(deltaX < 0 ? 1 : -1);
      touchStartX = null;
    });

    // Flechas del teclado mientras el modal esta abierto
    modal.addEventListener('keyup', (event) => {
      if (!modal.hasAttribute('open')) return;
      if (event.code === 'ArrowLeft') go(-1);
      if (event.code === 'ArrowRight') go(1);
    });

    // product-modal.js (Dawn) marca ".active" segun la miniatura que abrio
    // el modal -- se observa para que el contador/miniaturas arranquen
    // sincronizados con la foto que realmente se ve al abrir.
    const observer = new MutationObserver(() => {
      const index = getActiveIndex();
      if (index > -1) syncThumbsAndCounter(index);
    });
    items.forEach((el) => observer.observe(el, { attributes: true, attributeFilter: ['class'] }));
  }

  document.querySelectorAll('.product-media-modal').forEach(initModalNav);
})();
